/* nn-cartlock-v1 (2 Nov 2026, Kuching UTC+8, William): name necklace cart lock for the Ella cart page + cart drawer.
   - Removing a necklace line ([data-cart-remove][data-nn-design]) removes every line with the same _design_id in ONE
     /cart/update.js call (capture-phase listener, so the theme's single-line remove never runs for it).
   - Guard (cart page load, drawer render, after any theme cart update): per _design_id the necklace line is kept at qty 1,
     its add-on lines are set back to the hidden _addons map ({"variant id": qty}); missing add-on lines are re-added,
     extra / orphan add-on lines are removed. Old carts without _addons: the cart total of the design is compared with
     _estimate and a notice is shown when they differ.
   Client-side only: the staff order email flags estimate vs price paid as the backstop.
   nn-blank-guard-v1 (round-20261104c): a Personalised Name Necklace (English) line without a design (_design_id + _estimate),
   e.g. added from a quick view or an old link, is removed and the customer is sent back to the customizer. */
(function () {
  "use strict";
  if (window.__nnCartLock) return;
  window.__nnCartLock = "v1";
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var busy = false, fixes = 0, MAX_FIXES = 4, again = false;

  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? "POST" : "GET", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ("HTTP " + r.status)); return j; }); });
  }
  function onCartPage() { return document.body && document.body.classList.contains("template-cart"); }
  function cents(s) { var m = String(s || "").replace(/,/g, "").match(/(\d+(?:\.\d+)?)/); return m ? Math.round(parseFloat(m[1]) * 100) : null; }
  function notice(text) {
    var host = document.querySelector("#main-cart-items, [data-cart], .previewCart-wrapper") || document.body;
    var n = document.getElementById("nn-cart-notice");
    if (!n) { n = document.createElement("p"); n.id = "nn-cart-notice"; n.className = "nn-cart-notice"; n.setAttribute("role", "status"); host.insertBefore(n, host.firstChild); }
    n.textContent = text;
  }
  function refreshDrawer(cart) {
    var w = document.querySelector("#halo-cart-sidebar .previewCart-wrapper");
    [].forEach.call(document.querySelectorAll("[data-cart-count]"), function (c) { c.textContent = cart.item_count; });
    if (!w) return Promise.resolve();
    return fetch(ROOT + "cart?view=ajax_side_cart", { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (h) { w.innerHTML = h; });
  }
  function refresh(cart, msg) {
    if (msg) try { sessionStorage.setItem("nnCartMsg", msg); } catch (e) {}
    if (onCartPage()) { window.location.reload(); return Promise.resolve(); }
    return refreshDrawer(cart).then(function () { if (msg) { try { sessionStorage.removeItem("nnCartMsg"); } catch (e) {} notice(msg); } });
  }
  function designOf(it) { return it && it.properties && it.properties._design_id; }
  var NN_HANDLE = "personalised-name-necklace-english";
  function isBlank(it) { return it && it.handle === NN_HANDLE && !(it.properties && it.properties._design_id && it.properties._estimate); }
  function hasNN(root) { return !!(root && root.querySelector && root.querySelector('[data-nn-design], a[href*="/products/' + NN_HANDLE + '"]')); }

  /* ---- remove the whole design ---- */
  window.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest("[data-cart-remove][data-nn-design]");
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    var did = b.getAttribute("data-nn-design");
    if (b.getAttribute("aria-busy") === "true") return;
    b.setAttribute("aria-busy", "true");
    busy = true;
    api("cart.js").then(function (cart) {
      var up = {};
      cart.items.forEach(function (it) { if (designOf(it) === did) up[it.key] = 0; });
      return api("cart/update.js", { updates: up });
    }).then(function (cart) { busy = false; return refresh(cart, null); })
      .catch(function (err) { busy = false; b.removeAttribute("aria-busy"); if (window.console) console.warn("[nn-cart-lock] remove", err); });
  }, true);

  /* ---- guard ---- */
  function plan(cart) {
    var groups = {}, up = {}, add = [], warn = [], blank = 0;
    cart.items.forEach(function (it) { if (isBlank(it)) { up[it.key] = 0; blank++; return; } var d = designOf(it); if (d) (groups[d] = groups[d] || []).push(it); });
    Object.keys(groups).forEach(function (did) {
      var g = groups[did], necks = g.filter(function (it) { return it.properties._estimate; }), adds = g.filter(function (it) { return !it.properties._estimate; });
      if (!necks.length) { adds.forEach(function (it) { up[it.key] = 0; }); return; }   /* orphan add-ons */
      var nk = necks[0];
      necks.slice(1).forEach(function (it) { up[it.key] = 0; });
      if (nk.quantity !== 1) up[nk.key] = 1;
      var want = null;
      try { want = nk.properties._addons ? JSON.parse(nk.properties._addons) : null; } catch (e) { want = null; }
      if (want) {
        var seen = {};
        adds.forEach(function (it) {
          var v = String(it.variant_id), w = want[v] || 0;
          if (seen[v]) { up[it.key] = 0; return; }
          seen[v] = 1;
          if (it.quantity !== w) up[it.key] = w;
        });
        Object.keys(want).forEach(function (v) { if (!seen[v] && want[v] > 0) add.push({ id: Number(v), quantity: want[v], properties: { "_design_id": did } }); });
      } else {
        var est = cents(nk.properties._estimate), sum = 0;
        g.forEach(function (it) { sum += it.final_line_price; });
        if (est !== null && sum !== est) warn.push(nk.properties.Name || did);
      }
    });
    return { up: up, add: add, warn: warn, blank: blank };
  }
  function guard() {
    if (busy) { again = true; return; }
    busy = true;
    api("cart.js").then(function (cart) {
      var p = plan(cart), n = Object.keys(p.up).length;
      if (p.warn.length) notice("Please check your name necklace (" + p.warn.join(", ") + "): its cart lines don\u2019t match the design price. Remove it and add the design to your cart again.");
      if (!n && !p.add.length) { busy = false; return null; }
      /* never loop: at most MAX_FIXES repairs per 2 minutes (the cart page reloads after a repair) */
      var log = []; try { log = JSON.parse(sessionStorage.getItem("nnCartFixes") || "[]").filter(function (t) { return Date.now() - t < 120000; }); } catch (e) {}
      if (fixes >= MAX_FIXES || log.length >= MAX_FIXES) { busy = false; notice("Please check your name necklace lines: we couldn\u2019t match them to your design. Remove the necklace and add the design again."); return null; }
      fixes++; log.push(Date.now()); try { sessionStorage.setItem("nnCartFixes", JSON.stringify(log)); } catch (e) {}
      var step = n ? api("cart/update.js", { updates: p.up }) : Promise.resolve(cart);
      return step.then(function (c) { return p.add.length ? api("cart/add.js", { items: p.add }).then(function () { return api("cart.js"); }) : c; })
        .then(function (c) {
          busy = false;
          if (p.blank) {
            return refresh(c, "A name necklace needs your design first, so we\u2019ve taken the blank one out of your cart. Design yours at adovejewellery.com/pages/name-necklace and add it again.");
          }
          return refresh(c, "We\u2019ve kept your name necklace add-ons matched to your design.");
        });
    }).catch(function (err) { busy = false; if (window.console) console.warn("[nn-cart-lock] guard", err); })
      .then(function () { if (again) { again = false; setTimeout(guard, 300); } });
  }
  window.NNCartLock = { guard: guard, plan: plan };

  function start() {
    try { var m = sessionStorage.getItem("nnCartMsg"); if (m) { sessionStorage.removeItem("nnCartMsg"); notice(m); } } catch (e) {}
    if (onCartPage() || hasNN(document)) guard();
    document.addEventListener("cart-update", function () { setTimeout(guard, 50); });
    var w = document.querySelector("#halo-cart-sidebar .previewCart-wrapper"), t = 0;
    if (w && window.MutationObserver) new MutationObserver(function () {
      if (!hasNN(w)) return;
      clearTimeout(t); t = setTimeout(guard, 150);
    }).observe(w, { childList: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
